import { FieldSubject, PurchasePriceQuestion } from '@hb/domain';
import { PropertyStoreService } from '@hb/modules/property/property-store.service';
import { money } from '@hb/builder';
import { AbstractStoreInjectOption } from '@hb/services/store/abstract-store-inject.service';

import { inject, Injectable, OnDestroy } from '@angular/core';
import { Observable } from 'rxjs';

import { Money } from '@ap/interface-bspc-core';
import { PropertyType } from '@ap/ap-interface-apix-hypotheken-berekening';

@Injectable({
    providedIn: 'root'
})
export class PurchasePriceStoreService extends AbstractStoreInjectOption<PurchasePriceQuestion> implements OnDestroy {
    protected readonly store = inject(PropertyStoreService);
    protected readonly lastQuestion = PurchasePriceQuestion.SUMMARY;

    private readonly purchasePriceSubject: FieldSubject<Money>;

    constructor() {
        super();
        this.init();
        const initialValues = this.getInitialValues();
        this.purchasePriceSubject = new FieldSubject<Money>(initialValues);

        this.subscriptions();
    }

    ngOnDestroy(): void {
        super.ngOnDestroy();
        this.activeQuestionSubject.unsubscribe();
        this.purchasePriceSubject.unsubscribe();
    }

    getPurchasePrice(): Money {
        return this.purchasePriceSubject.value;
    }

    getPropertyType(): Observable<PropertyType> {
        return this.store.getPropertyType();
    }

    setPurchasePrice(purchasePrice: string): void {
        this.purchasePriceSubject.next(money(purchasePrice));
    }

    getInitialValues(): Money {
        return this.store.getPropertyState()?.purchase_price;
    }

    update(): void {
        this.store.setPurchasePrice(this.purchasePriceSubject.value);
    }

    private subscriptions(): void {
        this.purchasePriceSubject.asObservable().subscribe(() => {
            this.update();
        });

        this.store.getPropertyType().subscribe((propertyType: PropertyType) => {
            if (propertyType === PropertyType.NONE) {
                this.purchasePriceSubject.next(null);
                this.update();
            }
        });
    }
}
